import type { FieldType, TypeInstanceMap } from '@lighthouse/core'
import type { TriggerFlowNode } from '@lighthouse/shared'
import isDeepEqual from 'fast-deep-equal'
import React, { memo, useMemo } from 'react'

import { useErrorMap } from '../../hook/useErrorMap'
import { validateNode } from '../../utils/nodeValidator'
import { NodeSourceHandle } from '../Handle'
import NodeCard from './NodeCards'
import * as SC from './styles'

type SchemaType = {
    dsId: string
    dsName: string
    id: string
    innerType: TypeInstanceMap
    name: string
    type: FieldType
}
interface TriggerNodeProps extends TriggerFlowNode {
    isConnectable?: boolean
    firstTitle: string
    secondTitle: string
    schemaList: SchemaType[]
}

const TriggerNode: React.FC<TriggerNodeProps> = props => {
    const { id, selected, data, isConnectable } = props
    const { nodeType, status, config } = data
    const errorMap = useErrorMap(config)
    const errorMessage = useMemo(() => !validateNode(props) || errorMap?.[id], [errorMap, id, props])

    return (
        <SC.NodeWrapper selected={selected} status={status?.status}>
            <NodeCard nodeType={nodeType} errorMessage={errorMessage} data={data} />
            <NodeSourceHandle {...props} />
        </SC.NodeWrapper>
    )
}

export default memo(TriggerNode, (prevProps, nextProps) => {
    return isDeepEqual(prevProps.data, nextProps.data) && prevProps.selected === nextProps.selected
})
